<template>
  <div class="rounded">
    <div class="member-list__filter">
      <div>
        <b-checkbox
          v-model="isAllDepartmentSelected"
          native-value="all"
          @input="selectAllDepartments"
        >
          全部 ({{ allMemberCount }})
        </b-checkbox>
        <b-checkbox
          v-for="department in displayDepartments"
          v-model="selectedDepartments"
          :native-value="department.id"
          :key="department.id"
          @input="departmentChanged"
        >
          {{ getDepartmentName(department.id) }} ({{ getDepartmentCount(department.id) }})
        </b-checkbox>
      </div>
      <b-dropdown
        v-if="adjustable"
        :close-on-click="false"
        aria-role="list"
        class="flex-shrink-0"
        position="is-bottom-left"
      >
        <template #trigger>
          <w-button
            class="text-gray-500 text-xs"
            color-type="secondary"
            size="func"
            type="text"
          >
            <i class="icon-sort mr-2" />
            <span>欄位調整</span>
          </w-button>
        </template>

        <b-dropdown-item
          v-for="(column, index) in adjustableColumns"
          :key="index"
          aria-role="listitem"
        >
          <b-checkbox v-model="column.visible">
            {{ column.label }}
          </b-checkbox>
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div
      v-if="selectable && !isAllMemberSelected && !notAllowToEditMembers && !search"
      class="bg-primary-100 flex items-center px-2 py-1"
    >
      <w-button
        size="sm"
        @click="selectAllMembers"
      >
        全選
      </w-button>
      <p class="ml-2 text-sm">
        點擊按鈕即可將全員選加入至右側名單。
      </p>
    </div>
    <div v-if="warnEmpty && !departments.length" class="p-4">
      <p class="mb-2">
        尚未有其他人員喔，立即前往 <router-link to="/member/create">新增人員</router-link>！
      </p>
      <w-button @click="goToCreatePage">
        <i class="icon-plus mr-2" />
        <span>新增人員</span>
      </w-button>
    </div>
    <b-table
      v-else
      :checked-rows.sync="selectedMemberIds"
      :data="filteredMembers"
      :row-class="getRowClasses"
      checkable
      class="member-list__table"
      hoverable
      scrollable
      @click="toggleMember"
    >
      <b-table-column
        :th-attrs="columnThAttrs"
        :visible="columnVisibility.index"
        field="index"
        label="No."
        v-slot="props"
        width="28px"
      >
        {{ (currentPage - 1) * perPage + props.index + 1 }}.
      </b-table-column>
      <b-table-column
        :custom-sort="sortBySelected"
        :th-attrs="columnThAttrs"
        :visible="columns.indexOf('selected') > -1"
        field="selected"
        label="狀態"
        sortable
        v-slot="props"
        width="48px"
      >
        <template v-if="findTargetMemberId(props.row)">
          <font-awesome-icon
            :class="[
              checkMemberSelected(originSelectedMembers, props.row) ? 'text-gray-50' : 'text-black'
            ]"
            icon="check"
          />
        </template>
        <template v-else>
          <font-awesome-icon
            :class="[notAllowToEditMembers ? 'text-gray-50' : 'text-primary-500']"
            icon="plus"
          />
        </template>
      </b-table-column>
      <b-table-column
        :custom-sort="sortByField('name')"
        :th-attrs="columnThAttrs"
        :visible="columns.indexOf('name') > -1"
        field="name"
        label="姓名"
        sortable
        v-slot="props"
      >
        {{ props.row.member_detail.name }}
      </b-table-column>
      <b-table-column
        :custom-sort="sortByField('serial')"
        :th-attrs="columnThAttrs"
        :visible="columnVisibility.id"
        field="serial"
        label="人員編號"
        sortable
        v-slot="props"
        width="118px"
      >
        {{ props.row.member_detail.serial }}
      </b-table-column>
      <b-table-column
        :custom-sort="sortByField('department_id')"
        :th-attrs="columnThAttrs"
        :visible="columnVisibility.department"
        field="department_id"
        label="部門"
        sortable
        v-slot="props"
        width="162px"
      >
        {{ props.row.department_name }}
      </b-table-column>
      <b-table-column
        :custom-sort="sortByField('ext')"
        :th-attrs="columnThAttrs"
        :visible="columnVisibility.extension"
        field="ext"
        label="分機"
        sortable
        v-slot="props"
        width="162px"
      >
        {{ props.row.member_detail.ext }}
      </b-table-column>
      <b-table-column
        :custom-sort="sortByField('phone')"
        :th-attrs="columnThAttrs"
        :visible="columnVisibility.mobile"
        field="phone"
        label="手機號碼"
        sortable
        v-slot="props"
      >
        {{ props.row.member_detail.phone }}
      </b-table-column>
      <b-table-column
        :custom-sort="sortByField('note')"
        :th-attrs="columnThAttrs"
        :visible="columnVisibility.note"
        field="note"
        label="備註"
        sortable
        v-slot="props"
      >
        <div
          :title="props.row.member_detail.note"
          class="break-all max-w-[100px] truncate"
        >
          {{ props.row.member_detail.note }}
        </div>
      </b-table-column>

      <template #empty>
        <p class="my-12 text-center text-gray-700 text-sm">{{ emptyText }}</p>
      </template>
    </b-table>
  </div>
</template>

<script>
import MemberTable from './MemberTable';

export default MemberTable;
</script>

<style lang="scss" scoped>
@import './MemberTable';
</style>
